module.exports = __webpack_public_path__ + "static/inviteless3.b34a25f8.png";